export default __webpack_public_path__ + "static/media/logo.db50bd36.png";